import config from "../../config/config";

export const loginDonor = async (formData, csrfToken) => {
  const response = await fetch(`${config.BASE_URL}/donor/auth/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken,
    },
    credentials: "include",
    body: JSON.stringify(formData),
  });

  return response;
};

export { getCsrfToken } from "./userAuthApi";

